<script lang="ts">
  import { submitBtnText, isLoading, isChanged } from '../lib/stores/filters'
  import useActiveCategory from '../hooks/use-active-category'
  import useFilter from '../hooks/use-filter'
  import NavText from './NavText.svelte'
  import Spinner from './Spinner.svelte'
  import Button, { COLOR, TYPE } from './Button.svelte'

  const { closeActive, setActiveId, activeId, transitionDuration } = useActiveCategory()
  const { categories, buttons } = useFilter()
  const keys = Object.keys(categories)

  $: activeIdIndex = keys.indexOf($activeId)
  $: remaining = keys.filter((item) => item !== $activeId)
  $: backId = remaining[activeIdIndex % 2 ? 0 : 1]
  $: nextId = remaining[activeIdIndex % 2 ? 1 : 0]

  const changeActiveId = (id: string) => {
    closeActive()
    setTimeout(() => setActiveId(id), transitionDuration)
  }

  const onBack = () => changeActiveId(backId)
  const onNext = () => changeActiveId(nextId)
</script>

<div class="grid flex-shrink-0 grid-cols-4 gap-1 p-4">
  {#if $activeId && backId}
    <Button color={COLOR.LIGHT} on:click={onBack}>
      <NavText nav={categories[backId].nav} />
    </Button>
  {/if}
  <Button
    class="col-span-2 col-start-2 col-end-4"
    color={$isChanged ? COLOR.DANGER : COLOR.PRIMARY}
    disabled={$isLoading}
    type={TYPE.SUBMIT}
  >
    {#if $isLoading}
      <Spinner />
    {:else}
      {$submitBtnText}
    {/if}
  </Button>
  {#if $activeId && nextId}
    <Button color={COLOR.LIGHT} on:click={onNext}>
      <NavText nav={categories[nextId].nav} />
    </Button>
  {/if}
</div>
